export function applyPostTeamSwitchNavigation(): void {
  if (
    /^\/v2\/dataset_groups\/\d+\/audiences\/\d+(?:\/edit)?\/?$/.test(
      window.location.pathname
    )
  ) {
    window.location.assign('/audiences');
  } else if (/^\/experiments\/?$/.test(window.location.pathname)) {
    window.location.assign('/experiments');
  } else {
    window.location.reload();
  }
}
